import './ActivityModal.scss';

import { TSModal, type TSModalProps } from './TSModal';

export const ActivityModal = ({ isOpen, handleXClick, mainContent, className, ...props }: TSModalProps) => {
  const combinedClassName = 'activity-modal' + (className ? ` ${className}` : '');

  return (
    <TSModal
      mode="md"
      className={combinedClassName}
      backdropDismiss={false}
      handleXClick={handleXClick}
      isOpen={isOpen}
      mainContent={mainContent}
      {...props}
    />
  );
};
